module.exports = __webpack_public_path__ + "img/sankaku_52_red.a139aa0a.png";